export default "__VITE_ASSET__DcYmTDZ6__"